import { useMantineTheme } from "@mantine/core";

const useColors = () => {
  const theme = useMantineTheme();
  return theme.colors;
};

export default useColors;
